if (!customElements.get('dc-hero-film')) {
  customElements.define('dc-hero-film', class extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('template[data-film]')) {
        this.viewport = matchMedia('(max-width: 768px)');
        this.viewport.addEventListener('change', this.selectFilm);
      }
      this.selectFilm();
    }

    disconnectedCallback() {
      this.viewport?.removeEventListener('change', this.selectFilm);
      this.querySelector('video')?.pause();
    }

    selectFilm = () => {
      let video = this.querySelector(':scope > video');
      if (this.viewport) {
        const slot = this.viewport.matches ? 'mobile' : 'desktop';
        if (!video || video.dataset.slot !== slot) {
          const template = this.querySelector('template[data-film="' + slot + '"]');
          if (!template) return;
          const next = template.content.querySelector('video').cloneNode(true);
          next.dataset.slot = slot;
          video?.pause();
          if (video) video.replaceWith(next);
          else this.prepend(next);
          video = next;
        }
      }
      if (video && this.hasAttribute('data-autoplay') &&
          !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.muted = true;
        video.play().catch(() => { /* Leave the poster visible if the browser blocks autoplay. */ });
      }
    };
  });
}

if (!customElements.get('dc-volume-index')) {
  customElements.define('dc-volume-index', class extends HTMLElement {
    connectedCallback() {
      this.rebuild();
      document.addEventListener('shopify:section:load', this.rebuild);
      document.addEventListener('shopify:section:unload', this.rebuild);
      document.addEventListener('shopify:section:reorder', this.rebuild);
      window.addEventListener('scroll', this.schedule, {passive:true});
      window.addEventListener('resize', this.schedule);
    }
    disconnectedCallback() {
      for (const event of ['load','unload','reorder']) document.removeEventListener('shopify:section:'+event,this.rebuild);
      window.removeEventListener('scroll',this.schedule);
      window.removeEventListener('resize',this.schedule);
      cancelAnimationFrame(this.frame);
    }
    rebuild = () => {
      this.schedule(true);
    };
    schedule = (rebuild) => {
      if (rebuild === true) this.dirty = true;
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        if (this.dirty) {
          this.dirty = false;
          this.volumes = [...document.querySelectorAll('[data-dc-volume][id]')];
          this.replaceChildren(...this.volumes.map((volume,i) => {
            const a = document.createElement('a');
            a.href = '#'+volume.id;
            a.textContent = String(i+1).padStart(2,'0')+'.';
            a.setAttribute('aria-label',volume.querySelector('h2')?.textContent.trim() || 'Volume '+(i+1));
            return a;
          }));
        }
        let current = 0;
        this.volumes?.forEach((el,i) => {if(el.getBoundingClientRect().top <= innerHeight*0.4) current=i;});
        [...this.children].forEach((a,i)=>a.setAttribute('aria-current',String(i===current)));
      });
    };
  });
}
